import { render, staticRenderFns } from "./taskToTrans.vue?vue&type=template&id=46b63e2c&scoped=true&"
import script from "./taskToTrans.vue?vue&type=script&lang=js&"
export * from "./taskToTrans.vue?vue&type=script&lang=js&"
import style0 from "./taskToTrans.vue?vue&type=style&index=0&id=46b63e2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b63e2c",
  null
  
)

export default component.exports